const defaultFilter = null

const state = {
  clientDocumentAnalyzeFilter: defaultFilter
}

const getters = {}

const mutations = {
  SET_FILTER: (state, payload) => {
    state.clientDocumentAnalyzeFilter = payload
  }
}

const actions = {
  loadFilter({ commit }, filterData) {
    commit('SET_FILTER', filterData)
  },
  clearDocumentAnalyzeFilter({ commit }) {
    const defaultFilter = null
    commit('SET_FILTER', defaultFilter)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
